<script setup lang="ts">
import { defineProps } from 'vue'
import GridVue from '@/components/data-visualization/grids/GridVue.vue'
import type { Partner } from '@/api-swagger'
import ParentAttribution from '@/components/features/partners/ParentAttribution.vue'
import { usePartnerStore } from '@/stores/usePartnerStore'
import { useToast } from 'vue-toast-notification'
import CompanyGridActions from '@/components/features/companies/CompanyGridActions.vue'
const partnerStore = usePartnerStore()
const $toast = useToast()
const props = defineProps({
  data: {
    type: Array<Partner>,
    required: false,
  },
  showAddButton: {
    type: Boolean,
    default: true,
  },
})

const handleRemoveAttribution = async (params: any) => {
  await partnerStore
    .attributionParent(params.id, { parentId: 0 })
    .then(() => {
      $toast.success('Mise a jour effectuée')
    })
    .catch((error: { message: string }) => {
      $toast.error(error.message)
    })
}
</script>

<template>
  <grid-vue
    :list="props.data || []"
    :cols="[
      { field: 'name', headerName: 'Nom', filter: true, cellClass: 'border-0' },
      {
        field: 'action',
        headerName: 'Actions',
        resizable: false,
        filter: false,
        minWidth: 300,
        maxWidth: 300,
        cellRenderer: CompanyGridActions,
        cellRendererParams: {
          onClick: (params: any) => {
            handleRemoveAttribution(params)
          },
          tooltipPosition: 'left',
        },
        sortable: false,
        cellClass: 'border-0 grid-action',
      },
    ]"
  >
    <template #button>
      <parent-attribution child />
    </template>
  </grid-vue>
</template>
